
import User from '@/entities/User.js'

const user = (function(){
	return User.getInstance();
})();
export default user;